<lib-cmp-cadastro-list [ano]="ano" [enTheme]="enTheme" (itemClick)="onItemClick($event)"></lib-cmp-cadastro-list>
<button mat-fab class="btn-float" (click)="onNewClick($event)">
  <mat-icon>add</mat-icon>
</button>
